import owd from 'owd/owd';

export default class ImgLoad extends owd.Component {
	init() {
		this.bind();
	}

	bind() {
        this.on('load', (e) => {
            this.app.dom.$window.trigger('imageload', e.target);
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('img-load', {
	component: ImgLoad
});
